import React from 'react';
import Reflux from 'reflux';
import './Comment.css';
import ReactTooltip from 'react-tooltip';
import * as Utilities from '../Utilities';
import {Link} from 'react-router-dom';

export default class Topitem extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            prefix: this.props.prefix || '/topic/'
        };
    }
    componentWillReceiveProps (newProps) {
        let prefix = newProps.prefix || this.state.prefix;
        this.setState({
            prefix: prefix
        });
    }
    renderUsername (topic) {
        if (!topic.createdBy || !topic.createdBy.name) {
            return <a className='truncate'>Anónimo</a>;
        }
        return <Link className='truncate' to={'/p/' + topic.createdBy.username}>{topic.createdBy.screen_name}</Link>;
    }
    render () {
        let description = 'No hay datos';
        let topic = this.props.topic;
        topic.options.sort((opcion, option) => {
            if (opcion.position > option.position) {
                return 1;
            }
        });
        if (topic.options.length > 0) {
            description = '';
            description += '<div>' + '<span>' + topic.options[0].position + '</span>' + topic.options[0].sentence + '</div>';
        }
        if (topic.options.length > 1) {
            description += '<div>' + '<span>' + topic.options[1].position + '</span>' + topic.options[1].sentence + '</div>';
        }
        if (topic.options.length > 2) {
            description += '<div>' + '<span>' + topic.options[2].position + '</span>' + topic.options[2].sentence + '</div>';
        }
        return (
          <div key={topic._id + Math.floor(Math.random() * 1000) + 1} className='topicItemList'>
            <div className='colors2'>
              <div className='info-box'>
                <Link to={topic.createdBy ? '/p/' + topic.createdBy.username : '/'} className='content-img'>
                  <object type='image/jpg' data={topic.createdBy ? topic.createdBy.profile_image.sizeSmall : '/images/icons/default-big.jpg'} className='responsive-img'>
                    <img className='imgredes-rta img-thumbnail center-block' src='/images/icons/default-big.jpg' />
                  </object>
                </Link>
                <div className='txt-user-boxgrid'>
                  {this.renderUsername(topic)}
                  <img src='/images/flagarg.jpg' data-tip='Argentina' />
                  <ReactTooltip place='top' type='dark' />
                  <p>
                    {Utilities.getHumanTime(topic.updatedAt)}
                  </p>
                </div>
              </div>
              <h3><Link to={this.state.prefix + Utilities.getHumanUrl(topic)}>{topic.title}</Link></h3>
              <div className='rankid'>#{topic.id}</div>
              <div className='top-prev'>
                <p dangerouslySetInnerHTML={{__html: description}} />
              </div>
              <ul className='info-numbers'>
                <li className='left full-top'><Link to={this.state.prefix + Utilities.getHumanUrl(topic)}>+ Ver Top5</Link></li>
                <li><i className='fa fa-plus' aria-hidden='true' />{topic.likesCount}</li>
                <li><i className='fa fa-minus' aria-hidden='true' />{topic.dislikesCount}</li>
              </ul>
            </div>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/sections/TopItem.js